type additionalInfo = {
  validateUrlString(value: string, key: string): string;
};

const validateUrlString = (value: string, key: string) => {
  if (value.length === 0) return "";
  if (
    !(value.includes(".com") || value.includes(".net") || value.includes(".co"))
  )
    return "Invalid url.";
  if (value.trim().length > 100) return "Max 100 Characters.";
  return "";
};

const validator: additionalInfo = {
  validateUrlString: validateUrlString,
};

export default validator;
